import type React from 'react';

export default function OCPlus({ className = '', height = 20, width = 20 }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} height={height} viewBox="0 0 245.7 247.1" width={width}>
      <g fill="#FFFFFF">
        <path d="M38.8,123.6c0-46.3,37.7-84,84-84c19.8,0,38,6.9,52.4,18.4l23.3-28.8c-20.7-16.6-47-26.6-75.7-26.6 c-66.8,0-121,54.2-121,121c0,28.7,10,55,26.6,75.7l29.4-22.5C46,162.2,38.8,143.7,38.8,123.6z" />
        <path d="M220.5,52.1l-0.6,0.5l-28.8,22.1c9.9,13.8,15.7,30.6,15.7,48.8c0,46.3-37.7,84-84,84 c-19.1,0-36.8-6.4-50.9-17.2l-22.8,29.2c20.4,15.7,46,25,73.7,25c66.8,0,121-54.2,121-121C243.8,96.8,235.2,72.1,220.5,52.1z" />
        <polygon points="135.8,175.5 135.8,136.5 174.8,136.5 174.8,110.5 135.8,110.5 135.8,71.6 109.8,71.6 109.8,110.5 70.8,110.5 70.8,136.5 109.8,136.5 109.8,175.5" />
      </g>
    </svg>
  );
}
